import { Button, Grid, styled } from '@mui/material'
import { HeaderIcon } from 'src/utils/Icon'

export const ExplanationImg = styled('img')({ width: 180 })

export const LogoImg = styled('img')(({ theme }) => ({
  width: 440,

  [theme.breakpoints.down('sm')]: {
    width: 280,
  },
}))

export const RelativeGrid = styled(Grid)({ position: 'relative' })

// nav -------------

export const NavWrapperGrid = styled(Grid)(({ theme }) => ({
  backgroundImage: `url(${HeaderIcon.NavWrapper})`,
  backgroundRepeat: 'no-repeat',
  height: 43,
  backgroundSize: 'cover',
  borderRadius: 5,
  padding: 6,

  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}))

export const NavGrid = styled(Grid)({
  borderRight: '1px solid #96d1f0',
  cursor: 'pointer',

  ':last-child': {
    borderRight: 'none',
  },
})

export const NavText = styled('p')({
  margin: 0,
  color: '#006699',
  textAlign: 'center',

  ':hover': {
    textDecoration: 'underline',
  },
})

export const MenuBtn = styled(Button)(({ theme }) => ({
  width: 90,
  height: 80,
  backgroundImage: `url(${HeaderIcon.NavBtnWrapper})`,
  backgroundSize: 100,
  backgroundPosition: 'center center',
  borderRadius: 6,
  fontSize: 14,
  color: '#069',

  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}))

export const NavBtn = styled(MenuBtn)({
  width: 70,
  height: 44,
  position: 'absolute',
  top: 90,
  right: 0,
})

export const CloseBtn = styled(Button)({
  borderColor: 'white',
  fontSize: 16,
  color: 'white',
  borderRadius: 6,
  widht: 100,
  height: 37,
  marginTop: 16,
  marginRight: 16,
})
